import Axios from 'axios';

const testEnvironments = [
  'localhost:8080',
  'test01.vcv.team',
  'test02.vcv.team',
  'test03.vcv.team',
  'test04.vcv.team'
];

let integrationHost = process.env.INTEGRATION_HOST;

if (testEnvironments.includes(window.location.host)) {
  integrationHost = process.env.INTEGRATION_HOST_TEST;
}

if (window.location.hostname.indexOf('vcv.ai') > 0) {
  integrationHost = process.env.INTEGRATION_HOST_AI;
}

const getDefaultState = () => ({
  isAssessfirstLoading: false,
  isAssessfirstIntegrationStatus: false,
  integrationInterval: null,
  integrationIntervalCount: 0,
  // vacancy settings
  connectedVacancies: [],
  assessfirstLocales: [],
  assessfirstCurrentLocale: null,
  assessfirstCampaigns: [],
  assessfirstCurrentCampaign: null,
  assessfirstDropout: false,
  assessfirstDropoutPercent: 0
});

const state = getDefaultState();

const getters = {
  isVacancyAssessfirstConnected: state => {
    if (state.connectedVacancies.length > 0) {
      if (state.connectedVacancies[0].active) {
        return true;
      }
    }

    return false;
  },

  getAssessfirstLocalesForSelect: state => {
    let locales = [];

    for (const [key, value] of Object.entries(state.assessfirstLocales)) {
      locales.push({ code: key, name: value });
    }

    return locales;
  },

  getAssessfirstLocaleNameByCode: state => code => {
    if (state.assessfirstLocales[code] !== undefined) {
      return state.assessfirstLocales[code];
    } else {
      return false;
    }
  },

  getAssessfirstCampaignsForSelect: state => {
    if (state.assessfirstCampaigns.length > 0) {
      return state.assessfirstCampaigns.map(x => ({ code: x.id, name: x.label }));
    } else {
      return [];
    }
  },

  getAssessfirstCampaignNameById: state => id => {
    const index = state.assessfirstCampaigns.findIndex(x => x.id == id);

    if (index > -1) {
      return state.assessfirstCampaigns[index].label;
    }

    return '';
  }
};

const mutations = {
  SET_IS_ASSESSFIRST_LOADING: (state, payload) => {
    state.isAssessfirstLoading = payload;
  },

  STOP_INTERVAL_INTEGRATION_CHECK: state => {
    clearInterval(state.integrationInterval);
    state.integrationIntervalCount = 0;
  },

  INCREMENT_INTEGRATION_INTERVAL_COUNT: state => {
    state.integrationIntervalCount += 1;
  },

  SET_INTEGRATION_INTERVAL: (state, payload) => {
    state.integrationInterval = payload;
  },

  SET_ASSESSFIRST_INTEGRATION_STATUS: (state, payload) => {
    state.isAssessfirstIntegrationStatus = payload;
  },

  SET_CONNECTED_VACANCIES: (state, payload) => {
    state.connectedVacancies = payload;
  },

  SET_ASSESSFIRST_LOCALES: (state, locales) => {
    state.assessfirstLocales = locales;
  },

  SET_ASSESSFIRST_CURRENT_LOCALE: (state, locale) => {
    state.assessfirstCurrentLocale = locale;
  },

  SET_ASSESSFIRST_CAMPAIGNS: (state, campaigns) => {
    state.assessfirstCampaigns = campaigns;
  },

  SET_ASSESSFIRST_CURRENT_CAMPAIGN: (state, campaign) => {
    state.assessfirstCurrentCampaign = campaign;
  },

  SET_ASSESSFIRST_TOGGLE_DROPOUT: state => {
    state.assessfirstDropout = !state.assessfirstDropout;
  },

  SET_ASSESSFIRST_DROPOUT: (state, dropout) => {
    state.assessfirstDropout = dropout;
  },

  SET_ASSESSFIRST_DROPOUT_PERCENT: (state, percent) => {
    if (Number(percent) < 0) {
      state.assessfirstDropoutPercent = 0;
    } else if (Number(percent) >= 0 && Number(percent) <= 100) {
      state.assessfirstDropoutPercent = Number(percent);
    } else if (Number(percent) > 100) {
      state.assessfirstDropoutPercent = 100;
    }
  },

  RESET_INTEGRATIONS_HEADHUNTER(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  // Периодические запросы к интеграционному сервису чтобы увидеть когда появится access_token в params
  startIntervalIntegrationCheckAssessfirst({ commit, dispatch, state }) {
    const integrationInterval = setInterval(() => {
      if (state.integrationIntervalCount <= 6) {
        commit('INCREMENT_INTEGRATION_INTERVAL_COUNT');
        dispatch('grantAccessToAssessfirst');
      } else {
        commit('STOP_INTERVAL_INTEGRATION_CHECK');
        commit('SET_IS_ASSESSFIRST_LOADING', false);
      }
    }, 1000);

    commit('SET_INTEGRATION_INTERVAL', integrationInterval);
  },

  async grantAccessToAssessfirst({ commit, dispatch, rootGetters }) {
    commit('SET_IS_ASSESSFIRST_LOADING', true);
    commit('SET_ASSESSFIRST_INTEGRATION_STATUS', false);

    // Запрашиваем список интеграций (в новом списке должен появится access_token для каждой интеграции)
    await dispatch('integrations/fetchIntegrationsInstalls', null, { root: true });

    let apiToken = null; // Это токен который необходимо вернуть и вписать в поле токена в модальное окно после запроса
    const params = rootGetters['integrations/getIntegrationParams']('assessfirst');

    if (params.access_token) {
      commit('STOP_INTERVAL_INTEGRATION_CHECK');
    }

    if (params.access_token) {
      await Axios.get(`${integrationHost}/v1/assessfirst/auth/status`, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      })
        .then(async response => {
          commit(
            'integrations/SET_INTEGRATIONS_INSTALLS_STATUS',
            { code: 'assessfirst', value: response.data.ok },
            { root: true }
          );

          if (response.data.ok) {
            apiToken = await Axios.get(`${integrationHost}/v1/assessfirst/company`, {
              headers: { Authorization: `Bearer ${params.access_token}` }
            }).then(response => {
              commit('SET_ASSESSFIRST_INTEGRATION_STATUS', true);
              commit('STOP_INTERVAL_INTEGRATION_CHECK');
              commit('SET_IS_ASSESSFIRST_LOADING', false);

              return response.data.api_token;
            });
          } else {
            this._vm.$noty.error(window.$tr('integrations.assessfirst.need-valid-token'));
          }

          commit('SET_IS_ASSESSFIRST_LOADING', false);
        })
        .catch(() => {
          this._vm.$noty.error(window.$tr('common.error'));
        });
    }

    return apiToken;
  },

  async patchAssessfirstApiToken({ commit, rootGetters }, apiToken) {
    commit('SET_IS_ASSESSFIRST_LOADING', true);

    const params = rootGetters['integrations/getIntegrationParams']('assessfirst');

    if (params.access_token) {
      const params = { api_token: apiToken };

      await Axios.patch(`${integrationHost}/v1/assessfirst/company`, params, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      })
        .then(response => {
          if (response.data.active) {
            this._vm.$noty.success(window.$tr('integrations.token-accepted'));
          }
        })
        .catch(error => {
          if (error.response.status === 400) {
            this._vm.$noty.error(window.$tr('integrations.token-invalid'));
          }
        })
        .finally(() => {
          commit('SET_IS_ASSESSFIRST_LOADING', false);
        });
    }
  },

  // vacancy section
  async checkExistingConnection({ commit, getters, rootGetters }, vacancyId) {
    commit('SET_IS_ASSESSFIRST_LOADING', true);

    const params = rootGetters['integrations/getIntegrationParams']('assessfirst');

    if (params.access_token) {
      await Axios.get(
        `${integrationHost}/v1/assessfirst/vacancies?filter[vcv_vacancy_id]=${vacancyId}`,
        { headers: { Authorization: `Bearer ${params.access_token}` } }
      )
        .then(response => {
          const vacancyIndex = response.data._embedded.vacancies.findIndex(
            x => x.vcv_vacancy_id === vacancyId
          );

          commit('SET_CONNECTED_VACANCIES', response.data._embedded.vacancies);

          if (vacancyIndex > -1) {
            // set Current locale from server
            const currentLocale = response.data._embedded.vacancies[vacancyIndex].locale;
            const localeName = getters.getAssessfirstLocaleNameByCode(currentLocale);

            if (localeName) {
              commit('SET_ASSESSFIRST_CURRENT_LOCALE', { code: currentLocale, name: localeName });
            }

            // set Current campaign
            const currentCampaign = response.data._embedded.vacancies[vacancyIndex].campaign_id;
            const campaignName = getters.getAssessfirstCampaignNameById(currentCampaign);

            commit('SET_ASSESSFIRST_CURRENT_CAMPAIGN', {
              code: currentCampaign,
              name: campaignName
            });

            // set Current dropout
            commit(
              'SET_ASSESSFIRST_DROPOUT',
              response.data._embedded.vacancies[vacancyIndex].dropout_enabled
            );

            // set Current dropout treshold (percent)
            commit(
              'SET_ASSESSFIRST_DROPOUT_PERCENT',
              response.data._embedded.vacancies[vacancyIndex].dropout_threshold
            );
          }
        })
        .catch(() => {
          this._vm.$noty(window.$tr('common.error'));
        })
        .finally(() => {
          commit('SET_IS_ASSESSFIRST_LOADING', false);
        });
    }
  },

  async toggleAssessfirstToVacancy({ commit, dispatch, state, rootGetters }, vacancyId) {
    commit('SET_IS_ASSESSFIRST_LOADING', true);

    const params = rootGetters['integrations/getIntegrationParams']('assessfirst');

    if (params.access_token) {
      // Если вакансий прикрепленных нет, то нет и связи. Значит связь создаем через POST и автоматически она включается.
      if (state.connectedVacancies.length === 0) {
        const params = {
          active: true,
          vcv_vacancy_id: vacancyId
        };

        await Axios.post(`${integrationHost}/v1/assessfirst/vacancies`, params, {
          headers: { Authorization: `Bearer ${params.access_token}` }
        })
          .then(() => {
            dispatch('checkExistingConnection', vacancyId);
          })
          .catch(() => {
            this._vm.$noty(window.$tr('common.error'));
          })
          .finally(() => {
            commit('SET_IS_ASSESSFIRST_LOADING', false);
          });
      } else {
        // В остальных случаях меняем патчем значение active
        const currentConnect = state.connectedVacancies.find(x => x.vcv_vacancy_id === vacancyId);
        const params = {
          active: !currentConnect.active
        };

        await Axios.patch(
          `${integrationHost}/v1/assessfirst/vacancies/${currentConnect.id}`,
          params,
          { headers: { Authorization: `Bearer ${params.access_token}` } }
        )
          .catch(() => {
            this._vm.$noty(window.$tr('common.error'));
          })
          .then(() => {
            dispatch('checkExistingConnection', vacancyId);
          });
      }
    }
  },

  async fetchAssessfirstLocales({ commit, rootGetters }) {
    commit('SET_IS_ASSESSFIRST_LOADING', true);
    const params = rootGetters['integrations/getIntegrationParams']('assessfirst');

    if (params.access_token) {
      await Axios.get(`${integrationHost}/v1/assessfirst/locales`, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      })
        .then(response => {
          commit('SET_ASSESSFIRST_LOCALES', response.data);
        })
        .finally(() => {
          commit('SET_IS_ASSESSFIRST_LOADING', false);
        });
    }
  },

  async fetchAssessfirstCampaigns({ commit, rootGetters }) {
    commit('SET_IS_ASSESSFIRST_LOADING', true);
    const params = rootGetters['integrations/getIntegrationParams']('assessfirst');

    if (params.access_token) {
      await Axios.get(`${integrationHost}/v1/assessfirst/campaigns`, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      })
        .then(response => {
          commit('SET_ASSESSFIRST_CAMPAIGNS', response.data._embedded.vacancies);
        })
        .finally(() => {
          commit('SET_IS_ASSESSFIRST_LOADING', false);
        });
    }
  },

  async saveAssessfirstCampaign({ commit, rootState, rootGetters }) {
    commit('SET_IS_ASSESSFIRST_LOADING', true);
    const params = rootGetters['integrations/getIntegrationParams']('assessfirst');

    const currentConnect = state.connectedVacancies.find(
      x => x.vcv_vacancy_id === Number(rootState.vacancy_new.item.id)
    );

    const requestParams = {
      campaign_id: state.assessfirstCurrentCampaign.code,
      dropout_enabled: state.assessfirstDropout,
      dropout_threshold: Number(state.assessfirstDropoutPercent),
      locale: state.assessfirstCurrentLocale.code
    };

    await Axios.patch(
      `${integrationHost}/v1/assessfirst/vacancies/${currentConnect.id}`,
      requestParams,
      { headers: { Authorization: `Bearer ${params.access_token}` } }
    )
      .then(() => {
        this._vm.$noty.success(window.$tr('profile.info.save_success'));
      })
      .catch(() => {
        this._vm.$noty.error(window.$tr('profile.info.save_error'));
      })
      .finally(() => {
        commit('SET_IS_ASSESSFIRST_LOADING', false);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
